import React, { FC } from 'react'
import { Button } from 'react-bootstrap'

interface LoadMoreButtonProps {
  onClick: () => void
}

export const ButtonText = 'Load More'
export const LoadMoreButton: FC<LoadMoreButtonProps> = ({ onClick }) => {
  return (
    <Button id="loadMore" onClick={onClick}>
      {ButtonText}
    </Button>
  )
}
